import '../assets/css/manager.css';
import React from 'react';

const SearchBar = ({ value, onChange }) => {
    return (
        <div className='search-bar'>
            <div className="search-button">
                Որոնել
            </div>
            <input
                className="search-input"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            <div className="search-button">
                <i className="fas fa-search"/>
            </div>
        </div>
    );
};

export default SearchBar;
